module.exports = __webpack_public_path__ + "img/213-eb1051.png";